import requests from "./httpService";

const orderService = {
  // Create a cash order (returns { orderId, orderNumber })
  createCashOrder(payload) {
    return requests.post("/order/add", payload);
  },

  // Initiate a credit-card order via Tranzila (returns { orderId, orderNumber, tranzilaUrl })
  initiateCardPayment(payload) {
    return requests.post("/tranzila/initiate", payload);
  },

  // Poll order payment status after returning from Tranzila
  getOrderStatus(orderId) {
    return requests.get(`/tranzila/order-status/${orderId}`);
  },
};

export default orderService;
